import type { Camera } from 'types/camera';
import { SpotDetails } from 'types/spot';

const useCheckCameraSupportsSmartRewinds = (camera: Camera, spot: SpotDetails) =>
  !!camera.supportsSmartRewinds && !!spot?.insightsCameraId;

export default useCheckCameraSupportsSmartRewinds;
